<template>
  <div class="spellchecker-corrections" v-if="isCorrectionsVisible">
    <aha-tag
      v-for="(correction, correctionIndex) in misspell.corrections"
      :key="correctionIndex"
      :class="{'active': isCorrectionActive(correctionIndex)}"
      :size="'sm'"
      @click.stop="onCorrectionClicked(correctionIndex)"
      @keyup.enter.stop="onCorrectionClicked(correctionIndex)"
      tabindex="0"
      name="spellchecker-correction"
      v-aha-emit-action
    >
      {{ correction }}
    </aha-tag>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    misspell: {
      type: Object,
      default: () => {},
    },
    misspellIndex: {
      type: Number,
      default: null,
    },
  },

  computed: {
    hasOnlyOneCorrection() {
      return this.misspell?.corrections?.length === 1
    },

    isCorrectionsVisible() {
      return this.misspell?.id && !this.hasOnlyOneCorrection
    },

    isCorrectionActive() {
      return (correctionIndex) => {
        return this.misspell?.activeCorrectionIndex === correctionIndex
      }
    },
  },

  methods: {
    ...mapActions('spellchecker', ['setCorrectionForMisspellAction']),

    onCorrectionClicked(correctionIndex) {
      this.setCorrectionForMisspellAction({ misspellIndex: this.misspellIndex, correctionIndex })
    },
  },
}
</script>

<style lang="scss" scoped>
.spellchecker-corrections {
  @apply flex gap-2 mt-2;
}
</style>
